import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserModel} from 'src/app/models/user.model';
import {FeedService} from 'src/app/services/feed/feed.service';
import {ApiResponse} from 'src/app/services/utils';

@Component({
    selector: 'app-tag-user',
    templateUrl: './tag-user.component.html',
    styleUrls: ['./tag-user.component.scss'],
    standalone: false
})
export class TagUserComponent implements OnInit {

  @Output() tagUserEvent = new EventEmitter<any>();
  @Input() detailView: boolean;
  @Input() createPost: boolean;
  @Input() type: string;

  keyword = '';
  users: UserModel[];
  divMarginTop = '';

  constructor(private feedService: FeedService) {
  }

  ngOnInit() {
  }

  getItems(value) {
    this.keyword = value;
    if (this.keyword !== '') {
      this.feedService.apiHomeSearch('users', this.keyword, 1).subscribe((result: ApiResponse) => {
        if (result.status) {
          this.users = result.data.data;
        }
      });
    } else {
      this.users = [];
    }
  }

  public clearValue() {
    this.tagUserEvent.emit({user: {}});
    this.keyword = '';
    return;
  }

  public handleSelectTap($event, user): boolean {
    this.keyword = user.username;
    this.tagUserEvent.emit({user});
    this.users = [];
    return false;
  }

  getLabel(selection: any): string {
    return selection.username || '';
  }

}
